/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Vekn_Sponsor_ConfirmInputs */



/**
* | output |
* | --- |
* | "This will allocate a new VEKN ID to {name} and record you as their sponsor." |
*
* @param {Vekn_Sponsor_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_sponsor_confirm = /** @type {((inputs: Vekn_Sponsor_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Sponsor_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Cela attribuera un nouveau VEKN ID à ${i?.name} et vous enregistrera comme parrain.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Esto asignará un nuevo ID VEKN a ${i?.name} y lo registrará como su patrocinador.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Isso alocará um novo VEKN ID para ${i?.name} e registrará você como patrocinador.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questo assegnerà un nuovo VEKN ID a ${i?.name} e ti registrerà come sponsor.`)
	return /** @type {LocalizedString} */ (`This will allocate a new VEKN ID to ${i?.name} and record you as their sponsor.`)
});